export default __webpack_public_path__ + "static/media/rocket_anim_44.5ab41466.png";